module.exports = __webpack_public_path__ + "img/877d8cb35ac594e2885ac42ed896bd41.png";